import React, { useState, useEffect, useContext } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import AuthenticationService from "../../../Api/AuthenticationService";
import { AuthContext } from "../../../Context/AuthContext";
import ClientFooter from "../ClientFooter";

const StudentOtpVerification = () => {
    const AuthObject = new AuthenticationService();
    const [otp, setOtp] = useState("");
    const [error, setError] = useState("");
    const [timer, setTimer] = useState(60);
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();
    const token = location.state?.token;
    const email = location.state?.email;
    const { login } = useContext(AuthContext);

    useEffect(() => {
        if (!token && !email) {
            navigate('/StudentRegister');
            return;
        }

        const interval = setInterval(() => {
            setTimer((prev) => (prev > 0 ? prev - 1 : 0));
        }, 1000);

        return () => clearInterval(interval);
    }, [token, email, navigate]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError("");

        if (!otp || otp.length !== 6) {
            setError("Please enter a valid 6-digit OTP");
            return;
        }

        setIsLoading(true);
        try {
            const authData = {
                token,
                email,
                otp_code: otp
            };

            const success = await login(authData);

            if (success) {
                navigate('/'); // Navigate to home page after successful verification
            } else {
                setError("Invalid OTP. Please try again.");
            }
        } catch (error) {
            setError("Something went wrong. Please try again.");
        } finally {
            setIsLoading(false);
        }
    };

    const handleResendOtp = async () => {
        if (timer > 0) return;

        setIsLoading(true);
        try {
            const response = await AuthObject.ResendOtp({
                token,
                email
            });
            const data = await response.data;

            if (response.status === 200 && data.status === "success") {
                setTimer(60);
            } else {
                setError(data.message || "Failed to resend OTP. Please try again.");
            }
        } catch (error) {
            setError("Something went wrong. Please try again.");
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <>
            {/* Start breadcrumb Area */}
            <div className="rbt-breadcrumb-default ptb--100 ptb_md--50 ptb_sm--30 bg-gradient-1">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="breadcrumb-inner text-center">
                                <h2 className="title">OTP Verification</h2>
                                <ul className="page-list">
                                    <li className="rbt-breadcrumb-item">
                                        <a href="/" className="text-primary">
                                            <i className="feather-home me-1" />
                                            Home
                                        </a>
                                    </li>
                                    <li>
                                        <div className="icon-right">
                                            <i className="feather-chevron-right" />
                                        </div>
                                    </li>
                                    <li className="rbt-breadcrumb-item active">
                                        OTP Verification
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* End Breadcrumb Area */}

            <div className="rbt-elements-area bg-color-white rbt-section-gap">
                <div className="container">
                    <div className="row gy-5 row--30">
                        <div className="col-lg-6 offset-lg-3">
                            <div className="rbt-contact-form contact-form-style-1 max-width-auto">
                                <h3 className="title">OTP Verification</h3>
                                <p className="description mb-4">
                                    Please enter the verification code sent to your email
                                    <strong> {email}</strong>
                                </p>
                                {error && (
                                    <div className="alert alert-danger" role="alert">
                                        {error}
                                    </div>
                                )}
                                <form className="max-width-auto" onSubmit={handleSubmit}>
                                    <div className="form-group">
                                        <input 
                                            name="otp" 
                                            type="text" 
                                            value={otp}
                                            onChange={(e) => setOtp(e.target.value.replace(/\D/g, '').slice(0, 6))}
                                            maxLength={6}
                                            className={error ? 'is-invalid' : ''}
                                        />
                                        <label>Enter 6-digit OTP *</label>
                                        <span className="focus-border" />
                                    </div>

                                    <div className="form-submit-group">
                                        <button
                                            type="submit"
                                            className="rbt-btn btn-md btn-gradient hover-icon-reverse w-100"
                                            disabled={isLoading}
                                        >
                                            <span className="icon-reverse-wrapper">
                                                {isLoading ? (
                                                    <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                                ) : null}
                                                <span className="btn-text">Verify OTP</span>
                                                <span className="btn-icon">
                                                    <i className="feather-arrow-right" />
                                                </span>
                                                <span className="btn-icon">
                                                    <i className="feather-arrow-right" />
                                                </span>
                                            </span>
                                        </button>
                                    </div>

                                    <div className="form-group text-center mt-4">
                                        <p className="mb-0">
                                            Didn't receive the code?{" "}
                                            <button
                                                type="button"
                                                onClick={handleResendOtp}
                                                className={`text-primary border-0 bg-transparent ${(timer > 0 || isLoading) ? 'opacity-50 cursor-not-allowed' : ''}`}
                                                disabled={timer > 0 || isLoading}
                                            >
                                                Resend OTP {timer > 0 ? `(${timer}s)` : ''}
                                            </button>
                                        </p>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <ClientFooter/>
        </>
    );
};

export default StudentOtpVerification;
